<!--  -->
<template>
  <div class="emer_box">
    <el-input v-model="query.group_name" style="width:200px" placeholder="请输入企业组名" />
    <el-button type="primary" style="margin-bottom:20px;margin-left:10px" @click.stop="search">搜索</el-button>
    <el-button type="primary" style="margin-bottom:20px" @click.stop="addallconmoy">新增</el-button>
    <el-button type="primary" style="margin-bottom:20px" @click="qiweiclick">企微公司</el-button>
    <el-button type="primary" style="margin-bottom:20px" @click="zhanghuclick">企微账户</el-button>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="group_name"
        label="企业组名"
        width="180"
      />
      <el-table-column
        align="center"
        prop="message"
        label="消息"
        width="180"
      />
      <!-- <el-table-column
        align="center"
        prop="timeHi"
        label="时间"
        width="180"
      /> -->

      <el-table-column
        align="center"
        prop="company.company_name"
        label="企微公司"
        width="180"
      />
      <el-table-column
        align="center"
        prop="account.account"
        label="企微账户"
        width="180"
      />
      <el-table-column
        :key="mathRandom"
        align="center"
        prop="address"
        label="是否纳入"
        width="180"
      >
        <template slot-scope="scope">
          <div style="position: relative; display: inline-block;">
            <el-switch
              v-model="scope.row.ster"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="naclick(scope.row)"
            />
            <div
              v-if="scope.row.ster"
              style="color: #fff;position: absolute;top: 2px;left: 7px;"
            >已控制</div>
            <div
              v-else
              style="color: #fff;position: absolute;top: 2px;right: 7px;"
            >未控制</div>
          </div>

        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editwe(scope.row)">编辑</el-button>
          <el-button type="primary" size="mini" @click="deleter(scope.row.id)">删除</el-button>
          <el-button type="primary" size="mini" @click="send(scope.row.id)">发送记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="60%"
      @close="closempty"
    >
      <div ref="main" class="link_box">
        <div class="sers">
          <div>公司：</div>
          <div>
            <el-select v-model="company_id" placeholder="请选择企微公司">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.company_name"
                :value="item.id"
              />
            </el-select>
          </div>

        </div>
        <div class="sers" style="margin:20px 0px 20px 0px">
          <div>账户：</div>
          <div>
            <el-select v-model="account_id" placeholder="请选择企微账户">
              <el-option
                v-for="item in optionsr"
                :key="item.id"
                :label="item.account"
                :value="item.id"
              />
            </el-select>
          </div>

        </div>

        <div v-for="item,indexr in arr" :key="indexr" class="addserbox">
          <div class="sers">
            <div>群名：</div>
            <el-input v-model="item.groupname" style="width:200px" placeholder="请输入内容" />
          </div>
          <div class="sers" style="margin-left:10px">
            <div>消息：</div>
            <el-input v-model="item.message" style="width:200px" placeholder="请输入内容" />
          </div>
          <!-- <div class="sers" style="margin:0 10px">
            <div>时间：</div>
            <el-time-picker
              v-model="item.time"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="任意时间点"
              :clearable="false"
              @change="timechagew(indexr,$event)"
            />
          </div> -->
          <div class="sers" style="margin:0 10px">
            <div>控制开关：</div>
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="item.control"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="konghzhiselect(indexr,$event)"
              />
              <div
                v-if="item.control"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >已控制</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >未控制</div>
            </div>
          </div>
          <el-button type="primary" style="margin-left:30px" @click="addbtn">+</el-button>
          <el-button v-if="indexr!==0" type="primary" style="margin-left:10px" @click="reducebtn(indexr)">-</el-button>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sunbit">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      @close="resrist"
    >
      <viewbigpictures ref="viewbig" />
    </el-drawer>

    <el-drawer
      title="我是标题"
      :visible.sync="drawerr"
      :with-header="false"
    >
      <wechatzhanghu />
    </el-drawer>

    <el-dialog
      title="编辑"
      :visible.sync="editdialogVisible"
      width="20%"
    >
      <editdialog ref="edirwe" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="发送记录"
      :visible.sync="paydialogVisible"
      width="60%"
    >
      <payrecorddialog ref="paydialog" />
    </el-dialog>
  </div>
</template>

<script>
import viewbigpictures from './components/viewbigpictures.vue'
import wechatzhanghu from './components/wechatzhanghu.vue'
import editdialog from './components/editdialog.vue'
import { wechatcompanying, wechatcompanyingaccount, wechatgroupaccount, wechatgroupccountlist, wechatcomupwechatgroup, deletegroupccount } from '@/api/providerAccountManagement/servicePorviderList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import payrecorddialog from './components/payrecorddialog.vue'
export default {
  components: {
    viewbigpictures,
    wechatzhanghu,
    editdialog,
    PaginationRight,
    payrecorddialog
  },
  data() {
    return {
      total: null,
      tableData: [],
      options: [],
      optionsr: [],
      account_id: null, // 企微账户
      company_id: null, // 企微公司
      index: 0,
      ster: null,
      dialogVisible: false,
      editdialogVisible: false,
      paydialogVisible: false,
      arr: [
        {
          time: new Date(2022, 9, 10, 18, 40),
          control: true,
          groupname: '',
          message: '',
          controlchuan: 1,
          timechuan: '18:40'
        }
      ],
      drawer: false,
      drawerr: false,
      query: {
        group_name: null,
        page: 1,
        page_size: 10
      },
      mathRandom: null
    }
  },
  created() {
    this.getlist()
    this.adddata()
    this.adddatatwo()
  },
  mounted() {

  },
  methods: {
    closempty() {
      this.resutt()
    },
    search() {
      this.getlist()
    },
    // 获取列表
    async getlist() {
      const data = await wechatgroupccountlist(this.query)
      this.tableData = data.data.list
      data.data.list.forEach((res) => {
        if (res.include_status === 1) {
          res.ster = true
        } else {
          res.ster = false
        }
      })
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getlist()
    },
    timechagew(index, val) {
      // // this.arr[index].time = val
      // console.log(val)
      // const d = new Date(val)
      // let _h = d.getHours() + ''
      // if (_h.length === 1) {
      //   _h = '0' + _h
      // }
      // let _m = d.getMinutes() + ''
      // if (_m.length === 1) {
      //   _m = '0' + _m
      // }
      // this.arr[index].time = _h + _m
      console.log('timechagew', index, val)
      this.arr[index].timechuan = val
    },
    addbtn() {
      this.arr.push({
        time: new Date(2022, 9, 10, 18, 40),
        control: true,
        groupname: '',
        message: '',
        controlchuan: 1,
        timechuan: '18:40'
      })
      this.$nextTick(() => {
        const el = document.querySelector('.link_box')
        el.scrollTop = el.scrollHeight - el.clientHeight
      })
    },
    reducebtn(index) {
      this.arr.splice(index, 1)
    },
    // 确定
    async sunbit() {
      if (this.company_id === null) {
        this.$message.error('请选择企微公司')
        return
      }
      if (this.account_id === null) {
        this.$message.error('请选择企微账户')
        return
      }

      const arrsr = this.arr.map(item => ({
        group_name: item.groupname,
        message: item.message,
        // timeHi: item.timechuan,
        timeHi: '10:30',
        include_status: item.controlchuan
      })
      )

      const flag = this.arr.every(function(a) {
        return a.groupname !== ''// 数组中的每个元素的值都要大于2000的情况,最后才返回true
      })
      if (flag === false) {
        this.$message.error('请填写群组名')
        return
      }

      const flagr = this.arr.every(function(a) {
        return a.message !== ''// 数组中的每个元素的值都要大于2000的情况,最后才返回true
      })
      if (flagr === false) {
        this.$message.error('请填写消息')
        return
      }

      const data = await wechatgroupaccount({
        account_id: this.account_id,
        company_id: this.company_id,
        insert_data: arrsr
      })
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      this.dialogVisible = false
      this.getlist()
      this.resutt()
      console.log(data)
      console.log('this.arr', this.arr, arrsr)
    },

    qiweiclick() {
      this.drawer = true
    },
    zhanghuclick() {
      this.drawerr = true
    },
    resutt() {
      this.account_id = null
      this.company_id = null
      this.arr = []
      this.arr = [
        {
          time: new Date(2022, 9, 10, 18, 40),
          control: true,
          groupname: '',
          message: '',
          controlchuan: 1,
          timechuan: '18:40'
        }
      ]
    },
    resrist() {
      console.log('清空')
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.viewbig.resback()
      }, 100)
    },
    konghzhiselect(index, val) {
      console.log(index, val)
      this.arr[index].control = val
      if (val === true) {
        this.arr[index].controlchuan = 1
      } else {
        this.arr[index].controlchuan = 2
      }
    },
    addallconmoy() {
      this.dialogVisible = true
      this.adddata()
      this.adddatatwo()
    },
    async adddata() {
      const data = await wechatcompanying()
      this.options = data.data.list
      console.log('data', data)
    },
    async adddatatwo() {
      const data = await wechatcompanyingaccount()
      this.optionsr = data.data.list
      console.log('data', data)
    },
    async naclick(item) {
      console.log('item', item)
      let strs = null
      if (item.include_status === 1) {
        strs = 2
      } else {
        strs = 1
      }
      const id = item.id
      const account_id = item.account_id
      const company_id = item.company_id
      const group_name = item.group_name
      const message = item.message
      const timeHi = item.timeHi

      const data = await wechatcomupwechatgroup(id, account_id, company_id, group_name, message, timeHi, strs)
      console.log('data', data)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getlist()
      this.mathRandom = Math.random()
    },
    editwe(item) {
      this.editdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.edirwe.resback(item)
      }, 100)
    },
    updata() {
      this.editdialogVisible = false
      this.getlist()
    },
    async deleter(id) {
      const data = await deletegroupccount(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      console.log('data', data)
      this.getlist()
    },
    // 发送记录
    send(id) {
      this.paydialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.paydialog.customeoncallback(id)
      }, 100)
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.emer_box{
  padding: 20px;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}
.sers{
  display: flex;
  align-items: center;
}
.addserbox{
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.link_box{
  max-height: 300px;
  overflow: auto;
}
   /deep/ .el-drawer.rtl{
    width: 40% !important;
   }
.link_box::-webkit-scrollbar{ /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
.link_box::-webkit-scrollbar-thumb{ /*滚动条里面小方块*/
    border-radius: 10px;
    background: #cfcbcb;
}
.link_box::-webkit-scrollbar-track{ /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
}

</style>
